<template>
  <div>
    <top-nav>
      <router-link to="/">登录</router-link>
    </top-nav>
    <div class="register-container">
      <h1 class="register-title">用户注册</h1>
      <hr />
      <div v-if="step === 1" class="register-input">
        <div class="input-wrap">
          <input
            type="text"
            :class="{'err-input': errFields['phone']}"
            placeholder="手机号码"
            v-model="phone"
          />
        </div>
        <div class="input-wrap">
          <Slider
            ref="slider"
            class="input-border"
            @failed="slideFail"
            :sfunc="slideCheck"
            @success="slideSuccess"
          />
        </div>
        <div v-if="isSlide" class="input-wrap">
          <input
            type="text"
            :class="{'err-input': errFields['code']}"
            maxlength="6"
            placeholder="短信验证码"
            v-model="code"
            @change="doCheckCode"
            class="code-input"
          />
          <button :class="{'active-btn': canCode}" @click="doSendCode" class="code-tip">{{codeTip}}</button>
        </div>
        <div class="input-wrap">
          <label style="width:280px;position:relative;">
            <input
              :type="isSee ? 'text': 'password'"
              :class="{'err-input': errFields['password']}"
              maxlength="18"
              placeholder="6-18位密码，字母/数字/符号至少两种"
              v-model="password"
            />
            <svg-icon
              @click.native="isSee = !isSee"
              :iconClass="isSee? 'seye' : 'ceye'"
              class="eye-icon"
            />
          </label>
        </div>
        <div class="input-wrap">
          <div style="width:280px;display:inline-block;text-align:left;margin-bottom:30px;">
            <svg-icon
              @click.native="isAgree = !isAgree"
              :iconClass="isAgree? 'selected' : 'unselect'"
              class="select-icon"
            />
            <label @click="isAgree = !isAgree">
              <span>已阅读并接受</span>
              <a @click.stop target="_blank" href="agreement.html" class="link">用户协议</a>和
              <a @click.stop target="_blank" href="legal.html" class="link">隐私政策</a>
            </label>
          </div>
        </div>
      </div>

      <div v-if="step === 1">
        <button
          @click="doNext"
          :class="{'active-btn':canDoLogin}"
          class="login-button"
        >注&nbsp;&nbsp;册</button>
        <span class="error">{{errMsg}}</span>
      </div>

      <div v-else class="register-input">
        <svg-icon icon-class="suss" class="suss-icon" />
        <label class="suss-text">注册成功</label>
        <label>
          <span>去</span>
          <router-link class="login-link" to="/">登录></router-link>
        </label>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import TopNav from "../components/TopNav.vue";
import Footer from "../components/Footer.vue";
import Slider from "../components/Slider.vue";
import { sendCode, checkCode, addRegister } from "@/api/login";
import { isPoneAvailable, isvalidPassword } from "@/utils/validate";
const DEFAULT_TIP_TEXT = "获取验证码";
export default {
  name: "register",
  components: {
    TopNav,
    Footer,
    Slider
  },
  props: {
    msg: String
  },
  data() {
    return {
      step: 1,
      codeTip: DEFAULT_TIP_TEXT,
      errFields: {},
      errMsg: "",
      canCode: false,
      phone: "",
      password: "",
      code: "",
      isAgree: false,
      isSee: false,
      isSlide: false,
      isCode: false,
      sliderCode: ""
    };
  },

  destroyed() {
    if (this.tickTime) {
      clearInterval(this.tickTime);
    }
  },

  watch: {
    phone() {
      this.clearErr();
    },
    isAgree() {
      this.clearErr();
    },
    password() {
      this.clearErr();
      if (!isvalidPassword(this.password)) {
        this.$nextTick(() => {
          this.$set(
            this.errFields,
            "password",
            "密码不合法，字母/数字/字符至少包含两类"
          );
          this.errMsg = "6-18位，字母/数字/字符至少包含两类";
        });
      }
    },
    code() {
      this.clearErr();
    }
  },

  computed: {
    canDoLogin() {
      if (
        isPoneAvailable(this.phone) &&
        this.isCode &&
        this.isAgree &&
        isvalidPassword(this.password)
      ) {
        return true;
      }
      return false;
    }
  },

  methods: {
    doNext() {
      this.clearErr();
      if (!this.phone) {
        this.$set(this.errFields, "phone", "手机号码必须提供");
      }
      if (!this.code) {
        this.$set(this.errFields, "code", "验证码必须提供");
      } else if (!this.isCode) {
        this.$set(this.errFields, "code", "验证码错误");
      }
      if (!this.password) {
        this.$set(this.errFields, "password", "密码必须提供");
      } else if (!isvalidPassword(this.password)) {
        this.$set(
          this.errFields,
          "password",
          "密码不合法，字母/数字/字符至少包含两类"
        );
      }
      if (!this.isAgree) {
        this.$set(this.errFields, "isAgree", "阅读并接受条款");
      }
      let errFields = Object.keys(this.errFields);
      if (errFields.length > 0) {
        if (errFields.length === 1) {
          this.errMsg = this.errFields[errFields[0]];
        } else {
          this.errMsg = "信息填写错误";
        }
        return;
      }

      if (!this.canDoLogin) {
        return;
      }
      addRegister(this.phone, this.code, this.sliderCode, this.password).then(
        res => {
          if (res.success) {
            this.step = this.step + 1;
          } else {
            this.resetCheck();
            this.$nextTick(() => {
              this.errMsg = res.msg;
            });
          }
        }
      );
    },

    clearErr() {
      this.$set(this, "errFields", {});
      this.errMsg = "";
    },

    resetCheck() {
      this.code = "";
      this.canCode = false;
      this.sliderCode = "";
      this.isSlide = false;
      let slider = this.$refs.slider;
      if (slider) {
        slider.clean();
      }
    },

    slideFail() {
      this.sliderCode = "";
      this.isSlide = false;
      this.canCode = false;
    },
    slideCheck() {
      if (isPoneAvailable(this.phone)) {
        return true;
      } else {
        this.$set(this.errFields, "phone", "手机号码不正确");
        this.errMsg = "手机号码不正确";
        return false;
      }
    },

    slideSuccess(data) {
      if (!this.canCode) this.canCode = true;
      this.sliderCode = data.sliderCode;
      this.isSlide = true;
    },

    /**
     * 校验用户填写的验证码
     */
    doCheckCode() {
      if (this.code && this.code.length === 6) {
        checkCode("40", this.code, this.phone, this.sliderCode).then(res => {
          if (res.success) {
            this.isCode = true;
          } else {
            this.errMsg = res.msg;
          }
        });
      }
    },

    doSendCode() {
      if (this.canCode) {
        if (this.leftTime === undefined) {
          if (isPoneAvailable(this.phone)) {
            sendCode(this.sliderCode, this.phone, "40")
              .then(res => {
                if (res.success) {
                  this.leftTime = 60;
                  this.codeTip = this.leftTime + "s后可重发";
                  // 处理定时器
                  this.canCode = false;
                  // 启动定时器
                  this.tickTime = setInterval(() => {
                    if (this.leftTime > 0) {
                      this.leftTime = this.leftTime - 1;
                      this.codeTip = this.leftTime + "s后可重发";
                    } else {
                      this.leftTime = undefined;
                      this.codeTip = DEFAULT_TIP_TEXT;
                      clearInterval(this.tickTime);
                    }
                  }, 1000);
                } else {
                  this.errMsg = res.msg;
                }
              })
              .catch(() => {
                this.errMsg = "发送错误";
              });
          } else {
            this.$set(this, "errFields", {});
            this.$set(this.errFields, "phone", "手机号码错误");
            this.errMsg = "输入正确的手机号";
          }
          return;
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.register-container {
  max-width: 940px;
  margin: 0 auto;
  margin-top: 20px;
}
.register-title {
  color: #0c9af4;
  margin-bottom: 20px;
}
.register-input {
  margin-top: 50px;
}

.input-wrap {
  position: relative;
}

.input-wrap input {
  outline: none;
  border: 1px solid #cccccc;
  border-radius: 5px;
  line-height: 36px;
  box-sizing: border-box;
  padding: 0 10px;
  color: #333333;
}
.input-wrap input,
.input-border {
  margin-bottom: 16px;
  width: 280px;
}

.login-btn-container {
  padding-bottom: 30px;
}

.login-button {
  margin-top: 10px;
  width: 280px;
  line-height: 36px;
  background-color: #eef1f3;
  color: #666666;
  font-size: 14px;
  outline: none;
  border: 1px solid #cccccc;
  border-radius: 5px;
}

.login-button:focus {
  outline: none;
}
span.error {
  display: block;
  position: relative;
  top: 10px;
  color: red;
}

.login-tip-container {
  position: absolute;
  bottom: 10px;
  left: 20px;
  right: 50px;
}

.login-tip-container > span {
  font-size: 13px;
  margin-left: 5px;
  cursor: default;
}

.a-text {
  color: #0c9af4;
}

.tip-text {
  color: #c9c9c9;
}

.code-input {
  width: 160px !important;
}

.code-tip {
  position: relative;
  margin-left: 20px;
  height: 36px;
  width: 100px;
  outline: none;
  border: 1px solid #cccccc;
  background-color: #eef1f3;
  border-radius: 5px;
  font-size: 14px;
}

.link {
  color: #0c9af4;
  font-weight: bold;
}

.select-icon {
  margin-right: 5px;
}

.eye-icon {
  position: absolute;
  right: 10px;
  top: 4px;
  font-size: 18px;
  color: #716e6e;
}

.suss-icon {
  color: green;
  font-size: 30px;
}
.suss-text {
  color: green;
  font-size: 28px;
  display: inline-block;
  margin-left: 10px;
  margin-right: 30px;
}
.login-link {
  color: #0c9af4;
}

.active-btn {
  background-color: #0c9af4;
  color: white;
}

.err-input {
  border-color: red !important;
}
</style>
